/**
 * PATH: apps/billing/src/config/tabs.ts
 * PURPOSE: Billing Hub tab configuration for the shared tab system.
 */

import type { ComponentType } from 'react'
import { createTabStore, type TabNavigationConfig } from '@quotech/ui'
import {
  CreditCard,
  Repeat,
  BarChart3,
  Receipt,
} from 'lucide-react'

// ─── Tab Store ──────────────────────────────────────────────
export const useBillingTabStore = createTabStore({
  hubId: 'billing',
  defaultTab: { path: '/bills', title: 'Bills', iconKey: 'CreditCard' },
})

// ─── Icon Map ───────────────────────────────────────────────
const ICON_MAP: Record<string, ComponentType<{ className?: string }>> = {
  CreditCard,
  Repeat,
  BarChart3,
  Receipt,
}

// ─── Route Map ──────────────────────────────────────────────
const ROUTE_MAP: Record<string, { title: string; iconKey: string }> = {
  '/': { title: 'Bills', iconKey: 'CreditCard' },
  '/bills': { title: 'Bills', iconKey: 'CreditCard' },
  '/subscriptions': { title: 'Subscriptions', iconKey: 'Repeat' },
  '/usage': { title: 'Usage', iconKey: 'BarChart3' },
  '/invoices': { title: 'Invoices', iconKey: 'Receipt' },
}

// ─── Config ─────────────────────────────────────────────────
export const BILLING_TAB_CONFIG: TabNavigationConfig = {
  useStore: useBillingTabStore,
  routeMap: ROUTE_MAP,
  dynamicRoutes: [
    {
      pattern: /^\/bills\/(.+)/,
      getMetadata: (path) => ({
        title: `Bill #${path.split('/')[2]}`,
        iconKey: 'CreditCard',
      }),
    },
  ],
  excludedPaths: ['/sso', '/login', '/settings'],
  defaultNewTabPath: '/bills',
  iconMap: ICON_MAP as TabNavigationConfig['iconMap'],
}
